import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface UserKPICardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  variant?: "default" | "dark";
  testId?: string;
}

export function UserKPICard({ 
  title, 
  value, 
  icon: Icon, 
  variant = "default",
  testId
}: UserKPICardProps) {
  const isDark = variant === "dark";
  
  return (
    <Card 
      className={`border-0 shadow-sm ${isDark ? "text-white" : ""}`}
      style={isDark ? { backgroundColor: '#2D2D2D' } : {}}
      data-testid={testId}
    >
      <CardContent 
        className="p-0"
        style={{
          display: 'flex',
          padding: '16px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '8px'
        }}
      >
        <Icon className={`h-5 w-5 sm:h-6 sm:w-6 ${
          isDark ? "text-white" : "text-[#FF7A00]"
        }`} />
        <p className={`text-2xl sm:text-3xl font-bold space-grotesk ${
          isDark ? "text-white" : "text-gray-900"
        }`}>
          {typeof value === 'number' ? value.toLocaleString() : value}
        </p>
        <p className={`text-xs font-medium uppercase leading-tight tracking-[0.07px] ${
          isDark ? "text-gray-400" : "text-gray-500"
        }`}>
          {title}
        </p>
      </CardContent>
    </Card>
  );
}
